import React, { useState, useEffect } from 'react';
import { formatMoneda } from '../../../util/varios';
import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'

;

import useTableFijo from "../../useTableFijo"
import moment from 'moment';

const headCells = [
    { id: 'numfactura', label: 'Nº FACTURA', width: '50px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
    { id: 'fechaemision', label: 'FECHA EMISION', width: '50px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
    { id: 'descripcion', label: 'DECRIPCION', width: '250px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },

    { id: 'status', label: 'STATUS', width: '100px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
]


const TablaRelacionFacturas = props => {
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar3, setMostrar3] = useState(false);
    const [mostrar4, setMostrar4] = useState(false);
    const [contar, setContar] = useState(0);
    const [contar3, setContar3] = useState(0);
    const [activate, setActivate] = useState(false);


    const [records, setRecords] = useState([]);

    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableFijo(records, headCells, filterFn, 320);

    const [url, setUrl] = useState('');

    useEffect(() => {

        let op = require('../../../../src/modulos/datos');

        if (props.tabfacC) {
            setRecords(props.tabfacC);
        }

        console.log(props.tabfacC)

        if (op.reportes != null) {

            setUrl(op.reportes.trim());

        } else {
            setUrl('');
        }


    }, [props.tabfacC]);

    return (
        <div className="card">
            <div className="card-body">
                <div className="content" >
                    <div className="container">

                        <div className="row">

                            <div className="col-md-12" style={{ margin: "auto" }} >
                                <TblContainer container={{ height: 250, width: '100%', overflow: 'auto', padding: '2px' }} >
                                    <TblHead />

                                    <tbody>
                                        {

                                            records && records.map((item, index) => (
                                                <tr key={item.idfactura} style={{ padding: "0" }}>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.numfactura !== '' ? item.numfactura.trim() : ''}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{moment.utc(item.fechaemision).format('DD/MM/YYYY')}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.descripcion}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.status !== '' ? item.status.trim() : ''}</td>
                                                </tr>

                                            ))
                                        }
                                    </tbody>

                                </TblContainer>
                            </div>
                           
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );

}

export default TablaRelacionFacturas;
